import React, { useState } from 'react';
import axios from 'axios';
import {
    Box,
    Button,
    Card,
    CardMedia,
    Typography,
    Container,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const UploadCard = styled(Card)(({ theme }) => ({
    height: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey[200],
    borderRadius: 8,
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: theme.palette.grey[300],
    },
}));

const ImageCompare = () => {
    const [image1, setImage1] = useState(null);
    const [image2, setImage2] = useState(null);
    const [result, setResult] = useState(null);

    const handleImageUpload = (setImage) => (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const base64String = reader.result.split(',')[1];
                setImage(base64String);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleCompare = async () => {
        if (!image1 || !image2) {
            alert('Please upload two images');
            return;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/products/compare-images`, {
                image1: image1,
                image2: image2,
            }, {
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.data.isSame) {
                setResult(`Images are the same (Hamming distance: ${response.data.hammingdistance}) - Accept`);
            } else {
                setResult(`Images are different (Hamming distance: ${response.data.hammingdistance}) - Rejection`);
            }
        } catch (error) {
            setResult('Error comparing images');
            console.error(error);
        }
    };

    return (
        <Container maxWidth="md" sx={{ py: 4, bgcolor: 'background.default' }}>
            <Box sx={{ textAlign: 'center', mb: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Compare Product Images
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 4 }}>
                <label htmlFor="image-upload-1">
                    <UploadCard>
                        {image1 ? (
                            <CardMedia
                                component="img"
                                image={`data:image/jpeg;base64,${image1}`}
                                alt="Uploaded Image 1"
                                sx={{ height: '100%', objectFit: 'cover' }}
                            />
                        ) : (
                            <Typography variant="h6" color="text.secondary">
                                Upload Image 1
                            </Typography>
                        )}
                    </UploadCard>
                </label>
                <input
                    id="image-upload-1"
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload(setImage1)}
                    style={{ display: 'none' }}
                />
                <label htmlFor="image-upload-2">
                    <UploadCard>
                        {image2 ? (
                            <CardMedia
                                component="img"
                                image={`data:image/jpeg;base64,${image2}`}
                                alt="Uploaded Image 2"
                                sx={{ height: '100%', objectFit: 'cover' }}
                            />
                        ) : (
                            <Typography variant="h6" color="text.secondary">
                                Upload Image 2
                            </Typography>
                        )}
                    </UploadCard>
                </label>
                <input
                    id="image-upload-2"
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload(setImage2)}
                    style={{ display: 'none' }}
                />
            </Box>
            <Box sx={{ textAlign: 'center' }}>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={handleCompare}
                    sx={{ px: 4, py: 1.5, borderRadius: 2 }}
                >
                    Compare Images
                </Button>
            </Box>
            {result && (
                <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.100', borderRadius: 2, textAlign: 'center' }}>
                    <Typography variant="h6" color="text.primary">
                        {result}
                    </Typography>
                </Box>
            )}
        </Container>
    );
};

export default ImageCompare;